module.exports = __webpack_public_path__ + "static/media/sochi@2x.a4169147.jpg";